import { createSlice } from "@reduxjs/toolkit";
import {
  ClassCollectionDeleteAction,
  allOwnerCollectionlistAction,
  avatarAction,
  collectionDailyUsageAction,
  collectionEditAction,
  collectionShareAction,
  collectionShareWithPerticulerStudentAction,
  collectioncreateAction,
  collectiondeleteAction,
  collectiondetailsAction,
  collectionlistAction,
  collectionlistActionForSharedWithMe,
  deleteSelectedVideosFromCollection,
  resetCollectionAction,
  saveCollectionToSelf,
} from "../Action/CollectionAction";

const initialState = {
  collectionData: {},
  allOwnercollectionData: [],
  collectioncreateStatus: "idle",
  collectiondeleteStatus: "idle",
  collectionShareStatus: "idle",
  collectionShareFormClassStatus: "idle",
  collectionShareWithPerticulerStudentStatus: "idle",
  collectionEditStatus: "idle",
  deleteSelectedVideosFromCollectionStatus: "idle",
  avatar: "idle",
  collectionDetails: {},
  collectionDataSharedWithMe: [],
  collectionDailyUsageDetail: {},
  saveToSelf: [],
};

const collectionSlice = createSlice({
  name: "collection",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(collectionlistAction.fulfilled, (state, action) => {
        state.collectionData = action?.payload?.data;
      })

      .addCase(allOwnerCollectionlistAction.fulfilled, (state, action) => {
        state.allOwnercollectionData = action?.payload?.data;
      })

      .addCase(collectionShareAction.fulfilled, (state, action) => {
        state.collectionShareStatus = "succeeded";
      })

      .addCase(collectionEditAction.fulfilled, (state, action) => {
        state.collectionEditStatus = "succeeded";
      })
      .addCase(collectionDailyUsageAction.fulfilled, (state, action) => {
        state.collectionDailyUsageDetail = action?.payload?.data;
      })
      .addCase(collectioncreateAction.fulfilled, (state, action) => {
        state.collectioncreateStatus = "succeeded";
      })
      .addCase(collectiondeleteAction.fulfilled, (state, action) => {
        state.collectiondeleteStatus = "succeeded";
      })

      .addCase(ClassCollectionDeleteAction.fulfilled, (state, action) => {
        state.collectionShareFormClassStatus = "succeeded";
      })

      .addCase(collectiondetailsAction.fulfilled, (state, action) => {
        state.collectionDetails = action?.payload?.data;
      })

      .addCase(
        deleteSelectedVideosFromCollection.fulfilled,
        (state, action) => {
          state.deleteSelectedVideosFromCollectionStatus = "succeeded";
        }
      )

      .addCase(
        collectionShareWithPerticulerStudentAction.fulfilled,
        (state, action) => {
          state.collectionShareWithPerticulerStudentStatus = "succeeded";
        }
      )

      .addCase(avatarAction.fulfilled, (state, action) => {
        state.avatar = "succeeded";
      })

      .addCase(
        collectionlistActionForSharedWithMe.fulfilled,
        (state, action) => {
          state.collectionDataSharedWithMe = action?.payload?.data;
        }
      )
      .addCase(saveCollectionToSelf.fulfilled, (state, action) => {
        state.saveToSelf = action?.payload?.data;
      })

      .addCase(resetCollectionAction, () => initialState);
  },
});

export default collectionSlice.reducer;
